import styled from 'styled-components';
import { MEDIA } from '~/src/components/Footer/styled';
import { COLORS } from '@stelecom/ui-react/assets/js/constants';

export const ButtonsBlock = styled.div`
    width: 100%;
    justify-content: space-between;
  
    @media (max-width: 410px){
      flex-direction: column;
      gap: 7px;
    }
`;

export const MainButton = styled.button`
    font-size: 15px;
    width: 183px;
    height: 45px;
    border-radius: 8px;
    font-weight: bold;
    border: 1px solid #FC4C75;
    transition: opacity .3s ease-in-out;
  
    &:hover{
        cursor: pointer;
        opacity: 0.7;
    }
  
    @media (max-width: ${MEDIA.MOBILE425}){
        width: 160px;
    }
`;

export const ButtonPersonalArea = styled(MainButton)`
    color: ${COLORS.PINK_BRIGHT};
    background: transparent;
`;

export const ButtonPay = styled(MainButton)`
    color: #FFFFFF;
    background: ${COLORS.PINK_BRIGHT};
`;

export const CopyrightText = styled.p`
    color: ${COLORS.grey};
    font-size: 12px;
    line-height: 17px;
    margin-top: 25px;
`;

export const CopyrightLink = styled.a`
    border-bottom: 1px solid currentColor;
    color: currentColor;
    transition: 0.25s;

    &:hover {
        color: ${COLORS.black};
    }
`;
